export enum LineStatus{    
    None = "None",// [EnumDescription("هیچکدام")]  
    Available = "Available", // [EnumDescription("موجود")]   
    Reserved = "Reserved", // [EnumDescription("رزرو")]   
    InUse = "InUse", // [EnumDescription("در حال استفاده")]   
    Parked = "Parked", // [EnumDescription("معلق")]   
    NotforSale = "NotforSale", // [EnumDescription("غیر قابل فروش")]   
    WaitToActive = "WaitToActive"// [EnumDescription("در انتظار آزادسازی")]
}